import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardTab from './DashboardTab';
import ApplicantsTab from './ApplicantsTab';
import ContactsTab from './ContactsTab';
import AdminsTab from './AdminsTab';
import './AdminPanel.css';

const TABS = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'applicants', label: 'Applicants' },
  { key: 'contacts', label: 'Contacts' },
  { key: 'admins', label: 'Admins' }
];

const AdminPanel = ({ admin, onLogout }) => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout();
    navigate('/admin-login');
  };

  return (
    <div className="theme-page px-3">
      <section className="admin-panel-shell w-100 mx-auto text-white">
        <div className="d-flex flex-column flex-md-row align-items-md-end justify-content-between gap-4 mb-4">
          <div>
            <p className="theme-eyebrow mb-2">SRK Production</p>
            <h1 className="theme-title mb-2">Admin Panel</h1>
            <p className="theme-copy mb-0">
              {admin ? `Signed in as ${admin.name || admin.email} (${admin.role})` : 'Registered participants and payment status in one place.'}
            </p>
          </div>

          <div className="d-flex justify-content-md-end">
            <button type="button" className="btn theme-btn theme-btn-outline admin-panel-logout px-4" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>

        <div className="admin-panel-tabs mb-4">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`admin-panel-tab ${activeTab === tab.key ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {activeTab === 'dashboard' && <DashboardTab />}
        {activeTab === 'applicants' && <ApplicantsTab />}
        {activeTab === 'contacts' && <ContactsTab />}
        {activeTab === 'admins' && <AdminsTab admin={admin} />}
      </section>
    </div>
  );
};

export default AdminPanel;
